import { gql } from '@apollo/client';
import { type DocumentNode } from 'graphql';

export const GET_PAGE_CMS_EDITOR_DATA: DocumentNode = gql`
  query pageCmsEditorData($pageId: Int!, $communityId: Int!) {
    pageCMS(id: $pageId) {
      id
      pageNavTitle
      isHidden
      isExclude
      bannerImage {
        id
        hash
        extension
        url
        name
      }
      translations {
        id
        communityId
        field
        iso
        objectId
        objectType
        value
      }
      panels {
        id
        layout {
          size
          top
          bottom
          left
          right
        }
        config {
          __typename
          ... on TextPanelConfig {
            text
            buttonConfig {
              display
              category
              text
              url
              externalUrl
              targetType
            }
          }
          ... on ImagePanelConfig {
            imageFile {
              id
              hash
              extension
              url
              name
            }
            imageWidth
            imageAltText
            imageRoundedCorners
            buttonConfig {
              display
              category
              text
              url
              externalUrl
              targetType
            }
          }
          ... on VideoPanelConfig {
            embed
            videoUrl
            videoEmbedCode
          }
          ... on IdeasPanelConfig {
            ideasDisplay: display
            ideasDefault: default
            timespan
          }
          ... on LeaderboardPanelConfig {
            leaderboardDisplay: display
            leaderboardDefault: default
          }
          ... on ChallengeCarouselPanelConfig {
            favourites
            hideDescription
            includeUserChallenges
          }
          ... on LinePanelConfig {
            _empty
          }
          ... on ActivityPanelConfig {
            _empty
          }
          ... on BlogCarouselPanelConfig {
            _empty
          }
        }
      }
    }
    challenges(publicationStatus: PUBLISHED_AND_ARCHIVED, includeUserCreated: true) {
      id
      title
      archived
    }
    pages(communityId: $communityId, publicationStatus: PUBLISHED) {
      id
      title
      pageNavTitle
      type
      isHidden
    }
  }
`;
